import React, { useState } from 'react'
import RightSidebarGlobal from '../../Components/RightSidebarGlobal'
import who_we_are from "../../Assets/images/who_we_are.png";
import award_a from "../../Assets/images/award_a.png";
import award_b from "../../Assets/images/award_b.png";
import award_c from "../../Assets/images/award_c.png";
import AchievementDialog from '../../Components/AchievementDialog';

function Achievement() {

  const [addMaster, setAddMaster] = useState(false);
  const [masterPopup, setMasterPopup] = useState("");

  const addMasterFn = (masterPopup)=>{
    setMasterPopup(masterPopup)
    setAddMaster(true)
  } 


  return (
    <>
    <div class="wrapper">
    <div class="inner_page_Sec">
    <div class="col-sm-12 float-left left_sec searchPageTop">

    <h1>Achievement</h1>
    {/* <div class="award_sec_ben"> */}
	<div class="award_sec_ben_left_img">
	<div class="award_sec_ben_left_img_sub">
	  {/* <div class="wrapper_sm"> */}

		 <div class="col-sm-4 float-left">
		  	<div class="award_box">
		    <img src={award_a} alt="" onClick={() => {addMasterFn('award_a')}} /> </div>
		   <h3>Institutional Agency Award</h3>
		 </div>
		  
		 <div class="col-sm-4 float-left">
		  	<div class="award_box">
		    <img src={award_b} alt="" onClick={() => {addMasterFn('award_b')}} /> </div>
			 <h3>PPL Award</h3>
		 </div>
		  
		 <div class="col-sm-4 float-left">
		  	<div class="award_box">
		    <img src={award_c} alt="" onClick={() => {addMasterFn('award_c')}} /> </div>
			 <h3>Aspee Award</h3>
		 </div>
		  
	  {/* </div> */}
	</div>
	{/* </div> */}
</div>





    </div>
    {/* <div class="col-sm-4 float-left">
    <RightSidebarGlobal/>
    </div> */}

    </div>
    </div>

    <AchievementDialog
        visible={addMaster}
        onHide={() => setAddMaster(false)}
        boxName={masterPopup}
        // pdfUrl={pdfUrl}
        setAddMaster = {setAddMaster}
        // onAccountHeadAdded={fetchHeadAccountdownOption}
      />

    </>
  )
}

export default Achievement